import React from "react";
import {
  Shield,
  Crosshair,
  Activity,
  Flame,
  Eye,
  Compass,
  Layers,
  BookOpen,
  Box,
  LayoutGrid,
  Radio,
  Moon,
  HeartPulse,
  ShieldAlert,
  Sparkles,
} from "lucide-react";

const MAP = {
  Shield,
  Crosshair,
  Activity,
  Flame,
  Eye,
  Compass,
  Layers,
  BookOpen,
  Box,
  LayoutGrid,
  Radio,
  Moon,
  HeartPulse,
  ShieldAlert,
};

export const LucideIcon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Shield;
  return <Cmp {...props} />;
};

export default LucideIcon;
